<lvr-heading>{{ 'client.disability.proof_form.create' | transloco }}</lvr-heading>
<form [formGroup]="form" lvrAutoSave="disabilityProof" [entityId]="draftId" [autoLoad]="false">
	<section class="form">
		<div class="form-group">
			<!-- Date of SB-Ausweis -->
			@let sbProofCtrl = form.get('dateSbProof');
			<lvr-field
				[label]="'client.disability.proof_form.dateSbProof' | transloco | appendAsterisk"
				[matTooltip]="'client.disability.proof_form.sb_hint' | transloco"
			>
				<mat-form-field
					lvrInput
					[lvrError]="hasError(sbProofCtrl, 'maxDateExceeded', 'required', 'matDatepickerParse', 'dateTaken')"
				>
					<input
						matInput
						[matDatepicker]="picker"
						[max]="maxSbProofDate"
						formControlName="dateSbProof"
						placeholder="04.06.2013"
						[errorStateMatcher]="matcher"
					/>
					@if (hasError(sbProofCtrl, 'matDatepickerParse')) {
						<mat-error>{{ 'base.form.error.date_format_invalid' | transloco: { format: dateFormatHint } }}</mat-error>
					} @else if (hasError(sbProofCtrl, 'dateTaken')) {
						<mat-error>{{ 'base.form.error.date_taken' | transloco }}</mat-error>
					} @else if (hasError(sbProofCtrl, 'maxDateExceeded')) {
						<mat-error>{{ 'client.disability.proof_form.sb_present' | transloco }}</mat-error>
					} @else if (hasError(sbProofCtrl, 'required')) {
						<mat-error>{{ 'client.disability.proof_form.required' | transloco }}</mat-error>
					}
					<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
					<mat-datepicker #picker></mat-datepicker>
					<mat-hint>TT.MM.JJJJ</mat-hint>
				</mat-form-field>
			</lvr-field>
			<!-- SB-Status -->
			@let sbStatusCtrl = form.get('sbStatus');
			<lvr-field [label]="'client.disability.proof_form.sbstatus' | transloco | appendAsterisk">
				<lvr-searchable-select
					formControlName="sbStatus"
					[options]="disabilityStatus()"
					[placeholder]="'base.field.select_please' | transloco"
					[searchPlaceholder]="'base.field.search_placeholder' | transloco"
					[noResultsText]="'base.field.no_results' | transloco"
					[ariaLabel]="'client.disability.proof_form.sbstatus' | transloco"
					[required]="true"
					[hasError]="hasError(sbStatusCtrl, 'required')"
					[errorMessage]="'client.disability.proof_form.required' | transloco"
				></lvr-searchable-select>
			</lvr-field>
			<!-- Sonstiges text -->
			@if (shouldDisplayOtherText()) {
				@let otherTextCtrl = form.get('otherText');
				<lvr-field [label]="'client.disability.proof_form.other_text' | transloco | appendAsterisk">
					<mat-form-field
						lvrInput
						[lvrError]="hasError(otherTextCtrl, 'required')"
						[attr.aria-label]="'client.disability.proof_form.other_text' | transloco"
					>
						<input
							matInput
							maxlength="maxOtherTextLength"
							formControlName="otherText"
							placeholder="Sonstiges Freitextfeld"
							[errorStateMatcher]="matcher"
						/>

						@if (hasError(otherTextCtrl, 'required')) {
							<mat-error>{{ 'base.form.error.required' | transloco }}</mat-error>
						}
						<mat-hint>{{
							'client.relatives.create.hint.maxlength'
								| transloco: { actual: otherTextCtrl?.value?.length || 0, max: maxOtherTextLength }
						}}</mat-hint>
					</mat-form-field>
				</lvr-field>
			}
			<!-- limited / unlimited -->
			@if (!shouldDurationBeOptional()) {
				@let limitedCtrl = form.get('limited');
				<lvr-field [label]="'client.disability.proof_form.select_limited' | transloco | appendAsterisk">
					<div>
						@if (limitedCtrl?.hasError('required')) {
							<mat-error class="radio-group-error">{{ 'client.disability.proof_form.required' | transloco }}</mat-error>
						}
					</div>
					<mat-radio-group
						formControlName="limited"
						[attr.aria-label]="'client.disability.proof_form.select_limited' | transloco"
					>
						<mat-radio-button value="1">{{
							'client.disability.proof_form.unlimited_option' | transloco
						}}</mat-radio-button>
						<mat-radio-button value="2">{{
							'client.disability.proof_form.limited_option' | transloco
						}}</mat-radio-button>
					</mat-radio-group>
				</lvr-field>
				<!-- Expiry date for limit -->
				@if (limitedCtrl?.value === '2') {
					@let limitedUntilCtrl = form.get('limitedUntil');
					<lvr-field [label]="'client.disability.proof_form.limitedUntil' | transloco | appendAsterisk">
						<mat-form-field
							lvrInput
							[lvrError]="
								hasError(limitedUntilCtrl, 'maxDateExceeded', 'dateRangeExceeded', 'required', 'matDatepickerParse')
							"
						>
							<input
								matInput
								[matDatepicker]="limitedPicker"
								[min]="minLimitedDate"
								[max]="maxLimitedDate"
								formControlName="limitedUntil"
								placeholder="TT.MM.JJJJ"
								[errorStateMatcher]="matcher"
							/>
							@if (hasError(limitedUntilCtrl, 'matDatepickerParse')) {
								<mat-error>{{
									'base.form.error.date_format_invalid' | transloco: { format: dateFormatHint }
								}}</mat-error>
							} @else if (hasError(limitedUntilCtrl, 'required')) {
								<mat-error>{{ 'client.disability.proof_form.required' | transloco }}</mat-error>
							} @else if (hasError(limitedUntilCtrl, 'maxDateExceeded')) {
								<mat-error>{{ 'client.disability.proof_form.sb_max' | transloco: { max: 50 } }}</mat-error>
							} @else if (hasError(limitedUntilCtrl, 'dateRangeExceeded')) {
								<mat-error>{{ 'client.disability.proof_form.sb_range' | transloco }}</mat-error>
							}
							<mat-datepicker-toggle matIconSuffix [for]="limitedPicker"></mat-datepicker-toggle>
							<mat-datepicker #limitedPicker></mat-datepicker>
						</mat-form-field>
					</lvr-field>
				}
			}
			<!-- GbB Value -->
			@let gdbCtrl = form.get('gdbValue');
			<lvr-field [label]="'client.disability.proof_form.gdbValue' | transloco | appendAsterisk">
				<lvr-searchable-select
					formControlName="gdbValue"
					[options]="gdBValues()"
					[placeholder]="'base.field.select_please' | transloco"
					[searchPlaceholder]="'base.field.search_placeholder' | transloco"
					[noResultsText]="'base.field.no_results' | transloco"
					[ariaLabel]="'client.disability.proof_form.gdbValue' | transloco"
					[required]="true"
					[hasError]="hasError(gdbCtrl, 'required')"
					[errorMessage]="'client.disability.proof_form.required' | transloco"
					[hintText]="'client.disability.proof_form.gdb_value_hint' | transloco"
				></lvr-searchable-select>
			</lvr-field>
			<!-- Document Files -->
			@let filesCtrl = form.get('files');
			<lvr-document-upload
				[maxFileCount]="PROOF_SETTINGS.maxFiles"
				[hasError]="hasFileError(filesCtrl, 'requiredFile', 'maxFiles', 'maxFileSize', 'allowedFileTypes')"
				[multiple]="true"
				formControlName="files"
				[showIcon]="true"
				[ownerId]="client().uuid"
				[maxFileSize]="this.env.fileSettings.maxFileSize"
				[subjectType]="subjectType"
			>
			</lvr-document-upload>
		</div>
		<div class="form-group">
			<!-- Remark field -->
			@let remarkCtrl = form.get('remark');
			<lvr-field [label]="'base.field.remark' | transloco">
				<mat-form-field lvrInput [lvrError]="hasError(remarkCtrl, 'max')">
					<textarea
						matInput
						formControlName="remark"
						[placeholder]="'base.field.remark_placeholder' | transloco"
						[errorStateMatcher]="matcher"
						[maxlength]="maxRemarkLength"
					></textarea>
					@if (hasError(remarkCtrl, 'max')) {
						<mat-error>{{ 'base.form.error.max_length_exceeded' | transloco: { max: maxRemarkLength } }}</mat-error>
					}
					<mat-hint>{{
						'base.field.remark_hint' | transloco: { actual: remarkCtrl?.value?.length || 0, max: maxRemarkLength }
					}}</mat-hint>
				</mat-form-field>
			</lvr-field>
		</div>
		<p lvrPadding [padHorizontal]="16" [padVertical]="0">{{ 'base.form.required' | transloco }}</p>
	</section>

	<lvr-default-actions
		[disableSave]="form.invalid || !canCreateDisabilityReportsPermission()"
		[showLoading]="isLoading()"
		(save)="submitData()"
		(cancelSave)="cancel()"
	>
		<lvr-restore-actions entityType="disabilityProof" [entityId]="draftId"></lvr-restore-actions>
	</lvr-default-actions>
</form>
